/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * naming object
 * @export
 * @interface PutFleetsFleetIdSquadsSquadIdNaming
 */
export interface PutFleetsFleetIdSquadsSquadIdNaming {
    /**
     * name string
     * @type {string}
     * @memberof PutFleetsFleetIdSquadsSquadIdNaming
     */
    name: string;
}

/**
 * Check if a given object implements the PutFleetsFleetIdSquadsSquadIdNaming interface.
 */
export function instanceOfPutFleetsFleetIdSquadsSquadIdNaming(value: object): value is PutFleetsFleetIdSquadsSquadIdNaming {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PutFleetsFleetIdSquadsSquadIdNamingFromJSON(json: any): PutFleetsFleetIdSquadsSquadIdNaming {
    return PutFleetsFleetIdSquadsSquadIdNamingFromJSONTyped(json, false);
}

export function PutFleetsFleetIdSquadsSquadIdNamingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFleetsFleetIdSquadsSquadIdNaming {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function PutFleetsFleetIdSquadsSquadIdNamingToJSON(json: any): PutFleetsFleetIdSquadsSquadIdNaming {
    return PutFleetsFleetIdSquadsSquadIdNamingToJSONTyped(json, false);
}

export function PutFleetsFleetIdSquadsSquadIdNamingToJSONTyped(value?: PutFleetsFleetIdSquadsSquadIdNaming | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

